import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import { SanitizeHtmlPipe } from "./sanitize-html.pipe";

@Pipe({
  name: "safeNl2br"
})
export class SafeNl2BrPipe implements PipeTransform {
  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly sanitizeHtmlPipe: SanitizeHtmlPipe
  ) {}

  transform(value: string): SafeHtml {
    if (!value) {
      return "";
    }

    // First sanitize the HTML content
    const sanitized = this.sanitizeHtmlPipe.transform(value);

    // Then convert newlines to <br> tags
    const withBreaks = sanitized.toString().replace(/\r\n|\n/g, "<br>");

    // Return as safe HTML since we've already sanitized it
    return this.sanitizer.bypassSecurityTrustHtml(withBreaks);
  }
}
